module.exports = "/_next/static/images/prefooter-contact@2x_873ef7536c7e2da3f8a56a621bb2a1d1.png";